var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expand-class"},[_c('transition',{attrs:{"appear":"","name":"expand-height"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }